'use client';
import { useState, useEffect } from 'react';
import { autoUpdate } from '@s7/floating';
import { useDidUpdate } from '@s7/hooks';

function useFloatingAutoUpdate(options) {
    const { opened, floating: { refs: { reference, floating }, update }, position, positionDependencies } = options;
    const [delayedUpdate, setDelayedUpdate] = useState(0);
    useEffect(()=>{
        if (reference.current && floating.current) {
            return autoUpdate(reference.current, floating.current, update);
        }
        return undefined;
    }, [
        reference.current,
        floating.current,
        opened,
        delayedUpdate,
        position
    ]);
    useDidUpdate(update, positionDependencies);
    useDidUpdate(()=>{
        setDelayedUpdate((c)=>c + 1);
    }, [
        opened
    ]);
}

export { useFloatingAutoUpdate };
//# sourceMappingURL=useFloatingAutoUpdate.js.map
